import { render, staticRenderFns } from "./DaktelaEmailChannelForm.vue?vue&type=template&id=53d6ab32&"
import script from "./DaktelaEmailChannelForm.vue?vue&type=script&lang=js&"
export * from "./DaktelaEmailChannelForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports